import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { Results } from '@local/client-contracts';
import { isMac } from '@local/common-web';
import { UButtonComponent } from '@local/ui-infra';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SearchParamsService } from 'src/app/bar/services/search-params.service';
import { SortService } from 'src/app/bar/services/sort.service';
import { HeaderItem, ResultsOrigin } from '../../models/results-types';
import { getSortOptions } from '../../utils/sorts.utils';

@UntilDestroy()
@Component({
  selector: 'result-header',
  templateUrl: './result-header.component.html',
  styleUrls: ['./result-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultsHeaderComponent implements OnInit {
  @HostBinding('class.collection-item-header') get collectionItemHeader() {
    return this.isCollectionHeader;
  }

  @Input() model: HeaderItem;
  @Input() index: number;
  @Input() showRightButton: boolean;
  @Input() footer: boolean;
  @Input() selected: boolean;
  @Input() focusedGroup: number;
  @Input() showSort: boolean;
  @Input() showLauncherButton = false;
  @Input() launcherButtonText: boolean;
  @Input() isCollectionHeader: boolean;
  @Input() showResultSections: Results.ShowResultSections;
  @Input() view: string;
  @Output() clicked = new EventEmitter<ResultsOrigin>();
  @Output() buttonClicked = new EventEmitter<ResultsOrigin>();
  @Output() focusGroupClick = new EventEmitter<void>();
  @Output() openCollectionExternal = new EventEmitter<void>();

  isHeaderDate: boolean;
  isMac: boolean;

  constructor(
    public sortService: SortService,
    private searchParamsService: SearchParamsService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.isMac = isMac();
    this.isHeaderDate = this.model?.origin === 'header-date';
  }

  openSort(elm: UButtonComponent) {
    const popupRefSort = this.sortService.openSortPopup(elm.button, { sortOptions: getSortOptions(this.view) });

    popupRefSort.close$.pipe(untilDestroyed(this)).subscribe(() => {
      this.cdr.markForCheck();
    });
  }
}
